import axiosInstance from '../axiosInstance'; // Asegúrate de que esta ruta sea correcta

// Obtener todos los mantenimientos activos
export const fetchMaintenances = async () => {
  const response = await axiosInstance.get('/maintenance/records'); // Ruta general para todos los mantenimientos
  return response.data;
};

// Obtener un mantenimiento por ID
export const fetchMaintenanceById = async (id) => {
  const response = await axiosInstance.get(`/maintenance/records/${id}`); // Ruta para un mantenimiento específico
  return response.data;
};

// Obtener mantenimientos por ID de Componente (nueva funcionalidad)
export const fetchMaintenancesByComponentId = async (comId) => {
  const response = await axiosInstance.get(`/maintenance/records/component/${comId}`); // Ruta para mantenimientos de un componente
  return response.data;
};

export const fetchMaintenancesByVehicleId = async (vehId) => {
  const response = await axiosInstance.get(`/maintenance/records/component/${vehId}`); // Ruta para mantenimientos de un componente
  return response.data;
};

// (NUEVO) Mantenimientos por Vehículo
/*export const fetchMaintenancesByVehicleId = async (vehId) => {
  const { data } = await axiosInstance.get(`/maintenance/records`, { params: { vehid: vehId } });
  return data;
};*/

// Crear un mantenimiento
export const createMaintenance = async (data) => {
  const response = await axiosInstance.post('/maintenance/records', data);
  return response.data;
};

// Actualizar un mantenimiento
export const updateMaintenance = async ({ id, data }) => { // Espera un objeto { id, data } para la mutación
  const response = await axiosInstance.put(`/maintenance/records/${id}`, data);
  return response.data;
};

// Eliminar (lógicamente) un mantenimiento
export const deleteMaintenance = async ({ id, updbyid }) => { // Necesita 'updbyid' para la eliminación lógica
  const response = await axiosInstance.delete(`/maintenance/records/${id}`, { data: { updbyid } });
  return response.data;
};

// --- Funciones para la gestión de empleados en mantenimiento (si se necesitan en el frontend) ---
// Obtener empleados asignados a un mantenimiento
export const fetchMaintenanceEmployees = async (manId) => {
  const response = await axiosInstance.get(`/maintenance/records/${manId}/employees`);
  return response.data;
};

// Asignar un empleado a un mantenimiento
export const assignEmployeeToMaintenance = async ({ manId, empId, rolman, crebyid }) => {
  const response = await axiosInstance.post(`/maintenance/records/${manId}/employees`, { empid: empId, rolman, crebyid });
  return response.data;
};

// Quitar un empleado de un mantenimiento (lógicamente, si la tabla intermedia tiene EstReg)
export const removeEmployeeFromMaintenance = async ({ manId, empId, updbyid }) => {
  // Nota: DELETE con cuerpo.
  const response = await axiosInstance.delete(`/maintenance/records/${manId}/employees/${empId}`, { data: { updbyid } });
  return response.data;
};



// (NUEVO) Crear mantenimiento y luego agregar N detalles (helper)
export const createMaintenanceWithDetails = async ({ maintenance, details }) => {
  // 1) crea mantenimiento padre (debe incluir vehid, tipmanid, manfecini, etc.)
  const response = await axiosInstance.post('/maintenance/records', maintenance);
  return response.data; // devuelve el padre creado; los detalles los puedes consultar luego
};